// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__v69pq","head":"Table_head__3EaiM","col":"Table_col__3LuSb"};